import useTranslation from "hooks/useTranslation"
import { useParams } from "react-router-dom"
import { POST } from "api/request"
import { useState } from "react"
import * as url from 'api/urls'
import Modal from "./Modal"

interface AddPostModalProps {
  onClose: () => void
  onAddBook: () => void
}

const AddPostModal: React.FC<AddPostModalProps> = ({ onClose, onAddBook }) => {
  const { t } = useTranslation('addpostmodal')
  const [isInfoVisible, setInfoVisible] = useState<boolean>(false)
  const [signature, setSignature] = useState<string>('')
  const [isSending, setSending] = useState(false)
  const [desc, setDesc] = useState<string>('')
  const [isPublic, setPublic] = useState(true)

  const params = useParams()

  const handleSubmit = async () => {
    setSending(true)
    try {
      const response = await POST(url.addPost(params['*']), {
        body: {
          signature,
          text: desc,
          is_public: isPublic
        }
      })
      if (response.ok) {
        if (isPublic) {
          onAddBook()
          setInfoVisible(true)
        } else {
          onAddBook()
          onClose()
        }

      } else {
        alert('nie dodano - response false')
      }
      setSending(false)
    } catch (err) {
      console.error(err)
      setSending(false)
    }
  }

  return (
    <Modal
      icon='book'
      onClose={onClose}
      title={t('entry_in_book')}
      primaryDisabled={isSending}
      primaryButton={isInfoVisible ? '' : t('add_an_entry')} primaryButtonAction={handleSubmit}
      secondaryButton={isInfoVisible ? t('go_back_to_profile') : t('cancle')} secondaryButtonAction={'close'}>

      <div className="modal__addPost">
        {isInfoVisible
          ? <div className="info">
            <p>{t('your_book_entry_has_been_sent_to_the_plaque_owner_it_will_be_visible_after_their_approval')}</p>
          </div>
          : <>
            <div className="subtitle">{t('your_entry_will_be')} <span onClick={() => setPublic(!isPublic)}>{isPublic ? t('public') : t('private')}</span> </div>
            <div className="myInput">
              <label>{t('sign_not_required')}</label>
              <input
                type="text"
                placeholder={t('sign')}
                value={signature}
                onChange={(e) => setSignature(e.target.value)} />
            </div>

            <div className="myInput">
              <textarea
                placeholder={t('start_typing')}
                value={desc}
                onChange={(e) => setDesc(e.target.value)}></textarea>
            </div>
          </>}
      </div>

    </Modal>
  )
}

export default AddPostModal